import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import BadgesView from "@/components/shared/BadgesView";
import MilestoneThumbnailModal from "@/components/app/MilestoneThumbnailModal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BadgesTab({ clientId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editing, setEditing] = useState(null);

  const fetchBadges = useCallback(() => {
    setLoading(true);
    axios
      .get(`${API}/clients/${clientId}/badges`)
      .then((res) => setData(res.data))
      .catch(() => setError("Errore"))
      .finally(() => setLoading(false));
  }, [clientId]);

  useEffect(() => { fetchBadges(); }, [fetchBadges]);

  return (
    <div data-testid="badges-tab">
      <BadgesView
        data={data}
        loading={loading}
        error={error}
        canEdit
        onEditThumb={setEditing}
      />
      {editing && (
        <MilestoneThumbnailModal
          badge={editing}
          currentPath={editing.thumbnail_path}
          onClose={() => setEditing(null)}
          onChanged={() => {
            setEditing(null);
            fetchBadges();
          }}
        />
      )}
    </div>
  );
}
